import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

import Login from "@/layout/Login.vue";

// Admin pages



import UserProfile from "@/pages/UserProfile.vue";
/*import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Typography from "@/pages/Typography.vue";
import TableList from "@/pages/TableList.vue";*/

const routes = [
  {
    path: "/",
    redirect:"/dashboard",
    component: DashboardLayout,
    
    children: [
      {
        path: "/dashboard",
        name: "Bienvenido al panel",
        component: () => import('@/pages/Dashboard'),
      },
    ],
  },

  

  {
    path:"/columnas",
    name:"Columnas del sistema",
    component: DashboardLayout,
    children:[
      {
        path:'',
        component: () => import('@/pages/columnas/index'),
        name:"Columnas del sistema"
      },
      {
        path:'crear',
        name:'Crear columna',
        component:()=>import('@/pages/columnas/crear')
      },
      {
        path:'editar/:id',
        name:'Editar columna',
        component:()=>import('@/pages/columnas/editar')
      }
    ]
  },      


  {
    path:"/cuenta",
    component:DashboardLayout,
    name:"Cuenta",
    children:[{
          path:'',
          name:'Cuenta',
          component: () => import('@/pages/UserProfile'),
        }
    ]
  },

  
  {
    path:"/acceso",
    component:Login,
    name:"Login",
  },

  { path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
